import { Component } from 'react'
import { Route, Routes } from 'react-router'
import { inject, observer } from 'mobx-react'
import { withRouterProps } from '../../utils'
import GoalsStore from '../../models/Goals'
import { Goal, AddGoal } from './forms'
import { GoalsIncomeReplacement } from './IncomeReplacement'
import { GoalsDashboard } from './dashboard'
import { Page } from './elements'

class Goals extends Component {
  constructor(props) {
    super(props)
    const { store } = props
    this.state = GoalsStore.create({}, { store })
  }

  render() {
    const { location } = this.props

    return (
      <Page.Container>
        <Routes location={location}>
          <Route path='/add' element={<AddGoal />} />
          <Route path='/replace-income' element={<GoalsIncomeReplacement />} />
          <Route path='/:id/:edit?' element={<Goal />} />
          <Route path='/' element={<GoalsDashboard />} />
        </Routes>
      </Page.Container>
    )
  }
}

export default withRouterProps(inject('store')(observer(Goals)))
